import Translator from "../components/translator";

export class ValidateType {
	static phonePattern() {
		// validates phone numbers with or without country code
		return '^(([+]|00)( ?[0-9]{2}))?[0-9 ]{6,}$'
	}

	static emailPattern() {
		// Validates email adresses:
		return '^[\\w\\-+.]+@([\\w\\-.]{1,61}\\.)+[\\w\\-]{2,6}$'
	}

	static cvrPattern() {
		// validates Danish and norwegien VAT numbers: https://www.avalara.com/vatlive/en/eu-vat-rules/eu-vat-number-registration/eu-vat-number-formats.html
		return '^(DK)?([0-9][ ]?){8}([0-9](MVA)?)?$'
	}

	static eanPattern() {
		// validates Danish and Norwegien EAN numbers: https://www.gs1.dk/om-gs1/overblik-over-gs1-standarder/virksomhedspraefiks-landekoder
		return '^(57|70)[0-9]{11}$'
	}

	static zipCodePattern() {
		// Four digits
		return '^[0-9]{4}$'
	}

	static validateWordCount(data, min, max = null) {
		let words = 0

		if(data != null) {
			words = data.trim().split(/ +/).length;
		}

		if(words == null) {
			words = 0
		}

		if(words < min) {
			return Translator.translateReplace('%s indeholder ikke nok ord', [data], 'type-validation')
		}

		if(max !== null && words > max) {
			return Translator.translateReplace('%s indeholder for mange ord', [data], 'type-validation')
		}

		return true
	}

	static validatePhone(data) {
		let regex = new RegExp(ValidateType.phonePattern())

		if(regex.test(String(data))) {
			return true;
		}

		return Translator.translateReplace('%s er ikke et gyldigt telefonnummer', [data], 'type-validation')
	}

	static validateEmail(data) {
		let regex = new RegExp(ValidateType.emailPattern())

		if(regex.test(String(data))) {
			return true;
		}

		return Translator.translateReplace('%s er ikke en gyldig e-mail', [data], 'type-validation')
	}

	static validateCvr(data) {
		let regex = RegExp(ValidateType.cvrPattern());

		if(regex.test(String(data))) {
			return true;
		}

		return Translator.translateReplace('%s er ikke et gyldigt CVR-nummer', [data],'type-validation')
	}

	static validateEan(data) {
		let regex = RegExp(ValidateType.eanPattern());

		if(regex.test(String(data))) {
			return true;
		}

		return Translator.translateReplace('%s er ikke et gyldigt EAN-nummer', [data],'type-validation')
	}

	static validateZipCode(data) {
		let regex = RegExp(ValidateType.zipCodePattern())

		if(regex.test(String(data))) {
			return true;
		}

		return Translator.translateReplace('%s er ikke et gyldigt postnummer', [data],'type-validation')
	}

	static validateRequired(data) {
		let regex = RegExp('[\\S]')

		if(data != null && regex.test(String(data))) {
			return true;
		}

		return Translator.translate('Skal udfyldes','type-validation')
	}

	static validateLength(data, length) {
		if(String(data).length <= length) {
			return true;
		}

		return Translator.translateReplace('Må maks være %s tegn', [length],'type-validation')
	}
}